import _Vue from "vue";

export type TranslationDefinitionType = { [key: string]: string };

export function Responsive(Vue: typeof _Vue): void {
    const MOBILE_BREAKPOINT = 768;
    const TABLET_BREAKPOINT = 1024;
    const isMobile = () => window.innerWidth < MOBILE_BREAKPOINT;
    const isTablet = () => window.innerWidth < TABLET_BREAKPOINT;

    Vue.prototype.$responsive = _Vue.observable({
        isMobile: isMobile(),
        isTablet: isTablet()
    });
    window.addEventListener('resize', () => {
        Vue.prototype.$responsive.isMobile = isMobile()
        Vue.prototype.$responsive.isTablet = isTablet()
    });
}
